import { render, staticRenderFns } from "./PortalTemplate.vue?vue&type=template&id=652dd384&"
import script from "./PortalTemplate.vue?vue&type=script&lang=js&"
export * from "./PortalTemplate.vue?vue&type=script&lang=js&"
import style0 from "./PortalTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports